import React, { useEffect, useMemo } from 'react';
import { Box, FlexControlledForm, useDebounceState } from '@common-fe/common-fe';
import _ from 'lodash';

import { useSubmitFormStore } from '../../stores';

import { RolloverPayload, useStore } from './stores/useRollover.store';
import { useRolloverFields } from './hooks';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  onDirty?: (isDirty: boolean) => void;
}
const Rollover: React.FC<Props> = ({ isEditMode, onDirty, isTemplateMode }) => {
  const saveValidate = useSubmitFormStore((state) => state.saveValidate);
  const activateValidate = useSubmitFormStore((state) => state.activateValidate);
  const fields = useRolloverFields(isTemplateMode, isEditMode);
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<RolloverPayload>>();
  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);

  const key = useMemo(() => `rollover-${!!_.get(fields, '[2].value', '')}`, [fields]) as string;

  if (!fields.length) {
    return null;
  }
  return (
    <Box margin={{ top: 'spacing24' }}>
      <Box background="canvas" round="container1Round">
        <FlexControlledForm
          key={key}
          testId="plan_account-funding"
          formTitle="Rollover"
          fields={fields}
          showError={showErrors || activateValidate || saveValidate}
          editMode={isEditMode}
          onChangeValues={setValues}
          onDirty={onDirty}
          isThinMode
        />
      </Box>
    </Box>
  );
};
export default Rollover;
